import React from "react";
import Select from "react-select";
import { FeildWraper, FeildError, FormArea, FormLabel } from "../../../component/form/form-layout";

const Step1Form = ({ formik, stages, cTypes, customers, agents }) => {

    // console.log("stages", stages)
    // console.log("cTypes", cTypes)


    const mapOptions = (arrOrObj, labelKey = null, valueKey = "id") => {
        if (Array.isArray(arrOrObj)) {
            if (typeof arrOrObj[0] === "object") {
                return arrOrObj.map(i => ({ value: i[valueKey], label: i[labelKey] }));
            }
            return arrOrObj.map(i => ({ value: i, label: i }));
        } else if (typeof arrOrObj === "object") {
            return Object.entries(arrOrObj).map(([key, value]) => ({
                value: key,
                label: value
            }));
        } else {
            return [];
        }
    };



    return (
        <FormArea>
            {/* Stage */}
            <FeildWraper width="100%">
                <FormLabel required>Select Stage</FormLabel>
                <Select
                    options={mapOptions(stages)}
                    value={mapOptions(stages)?.find(o => o.value === formik.values.stage)}
                    onChange={(e) => formik.setFieldValue("stage", e.value)}
                    components={{ IndicatorSeparator: () => null, LoadingIndicator: () => null }}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                                ? "#f0f0f0"
                                : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: "0 0px 0",
                        }),
                        input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                        }),
                        singleValue: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#717680",
                        }),
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                        }),
                        menu: (base) => ({
                            ...base,
                            marginTop: "2px",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                                ? "#3b82f6"
                                : state.isFocused
                                    ? "#F3F4F6"
                                    : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                />
                {formik?.touched?.stage && formik.errors?.stage &&
                    <FeildError>{formik.errors.stage}</FeildError>
                }
            </FeildWraper>

            {/* C Type */}
            <FeildWraper width="100%">
                <FormLabel required>Select C Type</FormLabel>
                <Select
                    options={mapOptions(cTypes)}
                    value={mapOptions(cTypes)?.find(o => o.value === formik.values.c_type)}
                    onChange={(e) => formik.setFieldValue("c_type", e.value)}
                    components={{ IndicatorSeparator: () => null, LoadingIndicator: () => null }}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                                ? "#f0f0f0"
                                : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: "0 0px 0",
                        }),
                        input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                        }),
                        singleValue: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#717680",
                        }),
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                        }),
                        menu: (base) => ({
                            ...base,
                            marginTop: "2px",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                                ? "#3b82f6"
                                : state.isFocused
                                    ? "#F3F4F6"
                                    : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                />

                {formik?.touched?.c_type && formik.errors?.c_type &&
                    <FeildError>{formik.errors.c_type}</FeildError>
                }
            </FeildWraper>

            {/* Customer - Always visible */}
            <FeildWraper width="100%">
                <FormLabel required>Customer</FormLabel>
                <Select
                    options={mapOptions(customers, "name", "userid")}
                    value={mapOptions(customers, "name", "userid")?.find(
                        o => o.value === Number(formik.values.customer_id)
                    )}
                    onChange={(e) => formik.setFieldValue("customer_id", e.value)}
                    components={{ IndicatorSeparator: () => null, LoadingIndicator: () => null }}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                                ? "#f0f0f0"
                                : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: "0 0px 0",
                        }),
                        input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                        }),
                        singleValue: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#717680",
                        }),
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                        }),
                        menu: (base) => ({
                            ...base,
                            marginTop: "2px",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                                ? "#3b82f6"
                                : state.isFocused
                                    ? "#F3F4F6"
                                    : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                />

                {formik?.touched?.customer_id && formik.errors?.customer_id &&
                    <FeildError>{formik.errors.customer_id}</FeildError>
                }
            </FeildWraper>

            {/* Agent */}
            <FeildWraper width="100%">
                <FormLabel required>Select Agent</FormLabel>
                <Select
                    options={mapOptions(agents, "name", "userid")}
                    value={mapOptions(agents, "name", "userid")?.find(
                        o => o.value === Number(formik.values.agent_id)
                    )}
                    onChange={(e) => formik.setFieldValue("agent_id", e.value)}
                    components={{ IndicatorSeparator: () => null, LoadingIndicator: () => null }}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                                ? "#f0f0f0"
                                : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: "0 0px 0",
                        }),
                        input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                        }),
                        singleValue: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#717680",
                        }),
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                        }),
                        menu: (base) => ({
                            ...base,
                            marginTop: "2px",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                                ? "#3b82f6"
                                : state.isFocused
                                    ? "#F3F4F6"
                                    : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                />

                {formik?.touched?.agent_id && formik.errors?.agent_id &&
                    <FeildError>{formik.errors.agent_id}</FeildError>
                }
            </FeildWraper>
        </FormArea>
    );
};

export default Step1Form;
